import { gameTypeIcon } from "@/constants/homework";

export const getGameTypeIcon = type => gameTypeIcon[type] || "elsa-game-type";
